import { RefObject, useCallback, useRef, useState } from 'react';

interface UseIsScrolledProps {
  delta?: number;
}

interface UseIsScrolledReturn {
  scrollRef: RefObject<HTMLDivElement>;
  isScrolled: boolean;
  onScroll: () => void;
}

export const useIsScrolled = ({
  delta = 10,
}: UseIsScrolledProps = {}): UseIsScrolledReturn => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const onScroll = useCallback(() => {
    if (scrollRef.current) {
      setIsScrolled(scrollRef.current.scrollTop > delta);
    }
  }, [delta]);

  return { scrollRef, isScrolled, onScroll };
};
